// src/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Attach Authorization for every request from localStorage (not from a stale default)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

// extend src/api.js
let isRefreshing = false;
let pending = [];

const processQueue = (newToken, err) => {
  pending.forEach(({ resolve, reject, config }) => {
    if (newToken) {
      config.headers.Authorization = `Bearer ${newToken}`;
      resolve(api(config));
    } else {
      reject(err);
    }
  });
  pending = [];
};

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    if (!response) throw error; // network error

    // If unauthorized and we haven't retried yet, try refresh
    if (response.status === 401 && !config._retry) {
      config._retry = true;

      if (isRefreshing) {
        // queue while a refresh is in flight
        return new Promise((resolve, reject) => {
          pending.push({ resolve, reject, config });
        });
      }

      isRefreshing = true;
      try {
        const refresh = localStorage.getItem('refresh_token');
        if (!refresh) throw error;

        const { data } = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/token/refresh/`,
          { refresh }
        );

        localStorage.setItem('access_token', data.access);
        processQueue(data.access, null);
        isRefreshing = false;

        // retry original
        config.headers.Authorization = `Bearer ${data.access}`;
        return api(config);
      } catch (e) {
        isRefreshing = false;
        processQueue(null, e);
        // optional: clear storage and redirect to login
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.assign('/signin'); // or navigate('/login')
        throw e;
      }
    }

    throw error;
  }
);
